import { type VisibleFilterType } from '../api/gradingPortalApi.types';

/**
 * Visible filters for the AllSubmissions and NeedsReview tabs.
 * Excludes 'score' because those tabs show ungraded work where score is not applicable.
 */
export const GRADING_PORTAL_VISIBLE_FILTERS = [
    'gradingStatus',
    'programType',
    'cohortId',
    'requirementIdentifier',
    'graderId',
    'studentEmail',
    'olderThanDays',
    'projectVariant',
] as const satisfies ReadonlyArray<VisibleFilterType>;
